//import Cookies from 'js-cookie'

import Cookies from 'vue-cookie'

/* ----------------------------------------------------------------*/

export function getCookies(cookie) {
  let val = Cookies.get(cookie)
  try {
    val = JSON.parse(val)
  } catch (error) { }

  return val
}
export function setCookies(name, value, params = {}) {
  if (typeof value === 'object') {
    if(name=='TCG_UserInfo'){
      value['PostageDetails'] = [];
    }
    value = JSON.stringify(value)
  }

  //console.log(name, value, params,{ ...params })
  Cookies.set(name, value, { ...params });
  // return Cookies.set(name, value, { ...params });
}

export function removeCookies(name) {
  Cookies.remove(name)
  // return Cookies.remove(name)
}
export function getLocalStorage(cookie) {
  let val = window.localStorage.getItem(cookie)
  try {
    val = JSON.parse(val)
  } catch (error) { }

  return val
}
export function setLocalStorage(name, value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem(name, value);
  // return window.localStorage.setItem(name, value);
}
export function removeLocalStorage(name, value) {
  window.localStorage.removeItem(name)
  // return window.localStorage.removeItem(name)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js